<div class="modal-background" id="div_modal-background_d756a80d">
  <div class="close-button" (click)="close()" id="div_close-button_aac96e22">
    &times;
  </div>
  <!-- Close button added here -->
  <div id="div_af38efec">
    <div class="heading-modal" id="div_heading-modal_26caafa8">Welcome to</div>
    <div class="heading-modal margin-tp" id="div_heading-modal_ae2ff876">
      Trinity Rail Marketplace
    </div>
    <div class="sub-header-modal" id="div_sub-header-modal_64d5c251">
      We're glad you chose to be a part of the Trinity Rail Marketplace team,
      where you can browse and lease our expanding fleet of railcars in just a
      few clicks. Once you log in don't forget to check out some of the features
      in your Account by clicking on your name in the top right corner.
    </div>
    <ul class="modal-li" id="ul_modal-li_77651840">
      <li id="li_f92f62cb">Quickly search the entire Trinity fleet</li>
      <li id="li_16f40318">Easy and intuitive quote process</li>
      <li id="li_c7c2e12e">
        Keep track of previous quotes in Account Activity
      </li>
      <li id="li_51571419">Manage files in your own SDS repository</li>
    </ul>
    <button
      class="modal-button"
      (click)="startLease()"
      id="button_modal-button_302b1035"
    >
      Begin my first lease
    </button>
  </div>
</div>
